// extracted by mini-css-extract-plugin
module.exports = {"content":"PageContent__content___33E0V"};